import FirebaseModel from "./firebasemodel";
export default class Like extends FirebaseModel {
    likeCount;
    constructor(_model) {
        super(_model);
        this.likeCount = this.data.likeCount;
    }
}
